import { render, staticRenderFns } from "./AnnouncementResults.vue?vue&type=template&id=402bc15c&scoped=true&"
import script from "./AnnouncementResults.vue?vue&type=script&lang=js&"
export * from "./AnnouncementResults.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementResults.vue?vue&type=style&index=0&id=402bc15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402bc15c",
  null
  
)

export default component.exports